import { useAuth } from "@/hooks/useAuth";
import { User, LogIn, Shield } from "lucide-react";
import { NameDay } from "./NameDay";

export const Header = () => {
  const { isAuthenticated, user, loading, isAdmin, isModerator } = useAuth();

  const getRoleBadge = () => {
    if (isAdmin) {
      return (
        <a
          href="/admin"
          className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 transition-colors"
        >
          <Shield className="h-2.5 w-2.5" />
          Admin
        </a>
      );
    }
    if (isModerator) {
      return (
        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent/50 text-accent-foreground border border-accent">
          <Shield className="h-2.5 w-2.5" />
          Mod
        </span>
      );
    }
    return null;
  };

  return (
    <header className="w-full py-3 px-4 sm:px-6 border-b border-border/50 bg-card/50">
      <div className="max-w-5xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="group">
          <span className="font-display text-lg sm:text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
            korsordslexikon.se
          </span>
        </a>

        {/* Right side */}
        <div className="flex items-center gap-4 sm:gap-6">
          <NameDay />
          
          {!loading && (
            isAuthenticated ? (
              <a
                href="/konto"
                className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                <User className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">{user?.displayName || 'Konto'}</span>
                {getRoleBadge()}
              </a>
            ) : (
              <a
                href="/auth"
                className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                <LogIn className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">Logga in</span>
              </a>
            )
          )}
        </div>
      </div>
    </header>
  );
};
